/**
 * Lightweight site UI that must not depend on deferred vendors / jQuery.
 */
(function () {
  function initFooterAccordions(root) {
    var scope = root || document;
    scope.querySelectorAll('.footer-block__heading').forEach(function (heading) {
      if (heading.dataset.footerAccordionBound === 'true') return;
      heading.dataset.footerAccordionBound = 'true';
      heading.addEventListener('click', function () {
        var parent = heading.parentElement;
        if (parent) parent.classList.toggle('open');
      });
    });
  }

  function ensureLightbox() {
    var overlay = document.getElementById('rt-vanilla-lightbox');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'rt-vanilla-lightbox';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="rt-vanilla-lightbox__dialog" role="dialog" aria-modal="true">' +
      '<button type="button" class="rt-vanilla-lightbox__close" aria-label="Close">&times;</button>' +
      '<div class="rt-vanilla-lightbox__content"></div>' +
      '</div>';
    document.body.appendChild(overlay);

    if (!document.getElementById('rt-vanilla-lightbox-style')) {
      var style = document.createElement('style');
      style.id = 'rt-vanilla-lightbox-style';
      style.textContent =
        '#rt-vanilla-lightbox{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.9);padding:20px;}' +
        '#rt-vanilla-lightbox[hidden]{display:none!important;}' +
        '#rt-vanilla-lightbox .rt-vanilla-lightbox__dialog{position:relative;width:min(1400px,96vw);}' +
        '#rt-vanilla-lightbox .rt-vanilla-lightbox__content{width:100%;aspect-ratio:16/9;background:#000;border-radius:10px;overflow:hidden;}' +
        '#rt-vanilla-lightbox .rt-vanilla-lightbox__content img,#rt-vanilla-lightbox .rt-vanilla-lightbox__content iframe,#rt-vanilla-lightbox .rt-vanilla-lightbox__content video{width:100%;height:100%;object-fit:contain;border:0;display:block;}' +
        '#rt-vanilla-lightbox .rt-vanilla-lightbox__close{position:fixed;top:16px;right:20px;border:0;background:transparent;color:#fff;font-size:40px;line-height:1;cursor:pointer;}';
      document.head.appendChild(style);
    }

    function closeLightbox() {
      var content = overlay.querySelector('.rt-vanilla-lightbox__content');
      if (content) content.innerHTML = '';
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay || event.target.classList.contains('rt-vanilla-lightbox__close')) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !overlay.hasAttribute('hidden')) {
        closeLightbox();
      }
    });

    overlay._close = closeLightbox;
    return overlay;
  }

  function toEmbedUrl(url) {
    if (!url) return '';
    var ytMatch = url.match(
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/
    );
    if (ytMatch && ytMatch[1]) {
      return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
    }
    return url;
  }

  function openLightbox(href, width, height) {
    var overlay = ensureLightbox();
    var content = overlay.querySelector('.rt-vanilla-lightbox__content');
    var embedUrl = toEmbedUrl(href);
    var isImage = /\.(png|jpe?g|gif|webp|avif|svg)(\?|$)/i.test(href);
    var isVideoFile = /\.(mp4|webm|ogg)(\?|$)/i.test(href);

    content.innerHTML = '';
    if (width) content.style.maxWidth = width + 'px';
    if (height) content.style.aspectRatio = width && height ? width + ' / ' + height : '';

    if (isImage) {
      var img = document.createElement('img');
      img.src = href;
      img.alt = '';
      content.appendChild(img);
    } else if (isVideoFile) {
      var video = document.createElement('video');
      video.src = href;
      video.controls = true;
      video.autoplay = true;
      content.appendChild(video);
    } else {
      var iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      content.appendChild(iframe);
    }

    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function initFancyboxFallback(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-fancybox]').forEach(function (link) {
      if (link.dataset.vanillaLightboxBound === 'true') return;
      link.dataset.vanillaLightboxBound = 'true';
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href === '#') return;
        event.preventDefault();
        openLightbox(
          href,
          link.getAttribute('data-width'),
          link.getAttribute('data-height')
        );
      });
    });
  }

  function boot() {
    initFooterAccordions(document);
    initFancyboxFallback(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFooterAccordions(event.target);
    initFancyboxFallback(event.target);
  });
})();
